"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var determineTags = function (text, droppedText, finalText) {
    var result = finalText;
    var selfClosingTag = text.match(/<(.*?)(["\d\w\s])\/>/gi);
    if (selfClosingTag && result.indexOf('/>') === -1) {
        result = text
            .split('')
            .splice(0, text.indexOf('/>') + 2)
            .join('');
    }
    var openTags = droppedText.match(/(?!<\/)<([a-zA-Z0-9-"=\s/:.]*)>/g);
    var closingTags = droppedText.match(/<\/([a-zA-Z0-9-]*)>/g);
    if (closingTags && closingTags.length && (!openTags || openTags.length !== closingTags.length)) {
        var tagsFound_1 = {};
        closingTags.forEach(function (tag, i) {
            if (result.indexOf(tag) > -1) {
                tagsFound_1[i] = tag;
            }
            else {
                tagsFound_1[i] = false;
            }
        });
        closingTags.forEach(function (tag, i) {
            if (!tagsFound_1[i]) {
                result += tag;
            }
        });
    }
    result += '...';
    var openers = /</gi;
    var closers = />/gi;
    var openersMatch = result.match(openers);
    if (openersMatch && openersMatch.length !== result.match(closers).length) {
        return text;
    }
    return result;
};
var truncateByWords = function (text, maxWords) {
    if (!text)
        return '';
    var max = maxWords || 60;
    var splitText = text.split(' ');
    var finalText = text;
    if (splitText.length > max) {
        finalText = text
            .split(' ')
            .splice(0, max)
            .join(' ');
        var droppedText = text
            .split(' ')
            .splice(max, text.length)
            .join(' ');
        finalText = determineTags(text, droppedText, finalText);
    }
    return finalText;
};
exports.truncateByWords = truncateByWords;
var truncateByLength = function (text, limit) {
    if (!text)
        return '';
    var max = limit || 300;
    var finalText = text;
    if (text.length > max) {
        finalText = text
            .split('')
            .splice(0, max)
            .join('');
        var droppedText = text
            .split('')
            .splice(max, text.length)
            .join('');
        finalText = determineTags(text, droppedText, finalText);
    }
    return finalText;
};
exports.truncateByLength = truncateByLength;
//# sourceMappingURL=data:application/json;base64,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